import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <span class="selection-indicator"></span>

<span class="period-title">
  {{period-title
    this.rowValue
    showDateRange=true
    fullDay=this.selectKit.options.fullDay
  }}
</span>
*/
{
  "id": "vMAA4GEm",
  "block": "[[[10,1],[14,0,\"selection-indicator\"],[12],[13],[1,\"\\n\\n\"],[10,1],[14,0,\"period-title\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[30,0,[\"rowValue\"]]],[[\"showDateRange\",\"fullDay\"],[true,[30,0,[\"selectKit\",\"options\",\"fullDay\"]]]]]],[1,\"\\n\"],[13]],[],false,[\"period-title\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/period-chooser/period-chooser-row.hbs",
  "isStrictMode": false
});